import React, {useEffect, useRef, useState} from 'react';
import {useStores} from "../../../../stores/Context";
import axios from "axios";
import {useParams} from "react-router-dom";
import BtnPrimary from "../../../../boiteAOutils/BtnPrimary";
import ModalPrimary from "../../../../boiteAOutils/ModalPrimary";
import CrayonSvg from "../../../../boiteAOutils/SVG/CrayonSvg";
import BtnSvg from "../../../../boiteAOutils/BtnSvg";
import PaletteCouleurs from "../../../PaletteCouleurs";

const WidgetConsignesContentParametres = (props) => {
    const {id, ent} = useParams();
    const {widgetStore, consignesStore} = useStores();

    const [isLoad, setIsLoad] = useState(false);
    const [listTags, setListTags] = useState([]);
    const [newTag, setNewtag] = useState('');
    const [newTagColor, setNewtagColor] = useState('#FFFFFF');
    const [isNewTag, setIsNewTag] = useState(false);
    const [showDeleteTagModal, setShowDeleteTagModal] = useState({isOpen: false, idTag: ''})
    const [isEditCat, setIsEditCat] = useState({id: '', rename: ''});

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + '/api/getTagsByIdTotem/' + widgetStore.idTotem,
            {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
        ).then((res) => {
            setListTags(res.data);
            setIsLoad(true)
        })
    }, [isLoad])
    const handleAddTags = () => {
        if (newTag && newTagColor) {
            axios.post(process.env.REACT_APP_API_URL + '/api/addTagsByIdTotem', {
                    id_totem: widgetStore.idTotem,
                    nom: newTag,
                    color: newTagColor
                },
                {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
            ).then(() => {
                setNewtag('')
                setNewtagColor('#FFFFFF')
                setIsLoad(false)
                setIsNewTag(false)
            })
        } else {
            setIsNewTag(true)
        }
    }

    const handleDeleteTag = () => {
        if (showDeleteTagModal.idTag) {
            axios.post(process.env.REACT_APP_API_URL + '/api/deleteTagById', {
                    id: showDeleteTagModal.idTag
                },
                {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
            ).then(() => {
                setIsLoad(false)
                setShowDeleteTagModal({...showDeleteTagModal, isOpen: false, idTag: ''})
            });
        }
    }

    const handleUpdateTagName = () => {
        if (isEditCat.rename) {
            axios.post(process.env.REACT_APP_API_URL + '/api/updateTagsById', {
                id: isEditCat.id,
                rename: isEditCat.rename
            }).then(() => {
                setIsLoad(false);
                setIsEditCat({...isEditCat, id: '', rename: ''});
            })
        }
    }

    const handleUpdateTagColor = (id, color) => {
        axios.post(process.env.REACT_APP_API_URL + '/api/updateTagColorById', {
            id: id,
            color: color
        }).then(() => {
            setIsLoad(false);
        })
    }

    const handleColorClick = (color) => {
        setNewtagColor(color);
    };

    const colors = [
        "#FFFFFF", "#00B0FF", "#0B64CB", "#F8D541", "#FF9436",
        "#53CDBE", "#8B6DE2", "#F46AD5", "#66BE63", "#F82121"
    ];

    return (
        <div>
            <div className={`${props.createMode ? '' : 'consigneModifyBody'}`}>

                <div className={"consigneModifyHeader"}>
                    <h3 className={"consigneModifyTitleH3"}>Paramètres</h3>
                    <div onClick={() => consignesStore.resetViews()}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B"
                                  strokeWidth="2"/>
                            <line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B"
                                  strokeWidth="2"/>
                            <line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B"
                                  strokeWidth="2"/>
                        </svg>
                    </div>
                </div>

                <div className={"consigneModifyHeaderSeparateur"}></div>
                <div className={"consigneModifyBodyContent"}>
                    <label className={"consigneParamTitleH4"}>Catégories :</label>

                    <div className={"consigneParamListe"}>
                        {
                            listTags.length === 0 ? (
                                <div className={"consigneParamListeItems"}>
                                    <span>Aucune catégorie</span>
                                </div>
                            ) : (
                                listTags.map((data) => (
                                    <div className={"consigneParamListeItems"}>
                                        <div className={"consigneParamListeColor"}>
                                            <PaletteCouleurs
                                                className={"PaletteTagConsigne"}
                                                defaultColor={data.color}
                                                onColorChange={(color) => handleUpdateTagColor(data.id, color)}
                                            />
                                        </div>

                                        {
                                            isEditCat.id === data.id ? (
                                                <div className={"consigneParamListeName"}>
                                                    <input className={"consigneTagRemaneInput"} type={"text"}
                                                           value={isEditCat.rename}
                                                           onChange={(e) => setIsEditCat({
                                                               ...isEditCat,
                                                               rename: e.target.value
                                                           })}
                                                    />
                                                    <div onClick={() => handleUpdateTagName()}
                                                         style={{cursor: "pointer"}}>
                                                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none"
                                                             stroke="#00B0FF"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#000000"
                                                                  strokeWidth="2.5" strokeLinecap="round"
                                                                  strokeLinejoin="round" stroke="#00B0FF"/>
                                                        </svg>
                                                    </div>

                                                    <div
                                                        onClick={() => setIsEditCat({...isEditCat, id: '', rename: ''})}
                                                        style={{cursor: "pointer"}}>
                                                        <svg width="30" height="31" viewBox="0 0 40 41" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M10 10.499L31.2903 31.7893" stroke="#002335"
                                                                  strokeWidth="4" strokeLinecap="round"
                                                                  strokeLinejoin="round"/>
                                                            <path d="M10 31.7891L31.2903 10.4987" stroke="#002335"
                                                                  strokeWidth="4" strokeLinecap="round"
                                                                  strokeLinejoin="round"/>
                                                        </svg>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className={"consigneParamListeName"}>
                                                    <span className={"consigneParamListeNameLabel"}>{data.nom}</span>
                                                    <BtnSvg
                                                        svg={"crayon"}
                                                        width={30}
                                                        height={30}
                                                        onClick={() => setIsEditCat({
                                                            ...isEditCat,
                                                            id: data.id,
                                                            rename: data.nom
                                                        })}/>
                                                </div>
                                            )
                                        }


                                        <div className={"consigneParamListeTrash"}>
                                            <svg width="30" height="31" viewBox="0 0 20 21" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg"
                                                 onClick={() => setShowDeleteTagModal({
                                                     ...showDeleteTagModal,
                                                     isOpen: true,
                                                     idTag: data.id
                                                 })}
                                            >
                                                <path
                                                    d="M3.30809 16.6485L2.71726 4.83203H17.2814L16.6906 16.6485C16.6108 18.2451 15.293 19.4987 13.6944 19.4987H6.30435C4.70572 19.4987 3.38792 18.2451 3.30809 16.6485Z"
                                                    stroke="#F82121" strokeWidth="2"/>
                                                <path
                                                    d="M6.83398 4.5H13.1673V3.5C13.1673 2.39543 12.2719 1.5 11.1673 1.5H8.83399C7.72942 1.5 6.83398 2.39543 6.83398 3.5V4.5Z"
                                                    stroke="#F82121" strokeWidth="2"/>
                                                <path d="M0.833984 4.66797H19.1673" stroke="#F82121" strokeWidth="2"/>
                                                <path d="M12.5 9.66797V13.8346" stroke="#F82121" strokeWidth="2"/>
                                                <path d="M7.5 9.66797V13.8346" stroke="#F82121" strokeWidth="2"/>
                                            </svg>
                                        </div>


                                    </div>
                                ))
                            )
                        }

                    </div>

                    <h3 className={"consigneParamTitleH3"}>Ajouter une nouvelle catégorie :</h3>

                    <span className={"consigneParamLabel"}>Nom :</span>

                    <input type={"text"}
                           className={"consigneParamInputText"}
                           value={newTag}
                           onChange={(e) => {
                               setNewtag(e.target.value)
                           }}
                           placeholder={"Nom de la catégorie"}/>

                    <div className={"consigneParamContentColorChoix"}>
                        <span className={"consigneParamLabel"}>Couleur :</span>
                        <div className={"consigneParamContentColorListe"}>
                            {colors.map((color) => (
                                <div className={`${newTagColor === color ? 'consigneParamColorBtnSelected' : ''}`}>
                                    <div
                                        key={color}
                                        className={`consigneParamColorBtn ${newTagColor === color ? 'selected' : ''}`}
                                        style={{background: color}}
                                        onClick={() => handleColorClick(color)}
                                    ></div>
                                </div>

                            ))}
                        </div>
                    </div>

                    <div className={"consigneParamContentBtn"}>
                        <BtnPrimary onClick={() => {
                            handleAddTags()
                        }}>Ajouter la catégorie</BtnPrimary>
                    </div>
                </div>

            </div>
            {
                showDeleteTagModal.isOpen ? (
                    <ModalPrimary
                        textTitle={'Êtes-vous sur de vouloir supprimer cette catégorie ?'}
                        onCancel={() => setShowDeleteTagModal({...showDeleteTagModal, isOpen: false, idTag: ''})}
                        onValidate={handleDeleteTag}
                    />
                ) : null
            }
        </div>
    );
};

export default WidgetConsignesContentParametres;